'use strict';

var EventsService = function EventsService($timeout, itemsListService) {
  var ENTER_KEY = 13;
  var UPARROW_KEY = 38;
  var DOWNARROW_KEY = 40;
  var currentActiveIndex = 0;

  /**
   *
   * @param input
   * @param dropdownList
   * @param event
   */
  function onInputKeyPressHandler(input, dropdownList, event) {
    if (event.keyCode === ENTER_KEY) {
      var options = dropdownList.find('li a');
      if (options.size() === 1) {
        options.click();
      }
      input.blur();
    }
  }

  /**
   *
   * @param typeAhead
   * @param input
   * @param callback
   */
  function onInputClickHandler(typeAhead, input, callback) {
    input.select();
    if (typeAhead) {
      callback();
    }
  }

  /**
   *
   * @param scope
   * @param ngModelCtrl
   * @param input
   * @param elem
   */
  function onInputHandler(scope, ngModelCtrl, input, elem) {
    if (scope.typeAhead) {
      scope.$apply(function () {
        itemsListService.setEditableOption(scope, ngModelCtrl, input.val().toString());
        itemsListService.filterList(scope, input.val());
        elem.toggleClass('unselected-value', input.val() === scope.placeholder);
      });
    }
  }

  /**
   *
   * @param length
   * @param index
   * @param n
   * @returns {number}
   */
  function crawlArray(length, index, n) {
    return ((index + n) % length + length) % length;
  }

  /**
   *
   * @param scope
   * @param event
   */
  function onKeyDownHandler(scope, event) {
    var length = scope.filteredItemList.length;
    currentActiveIndex = scope.activeIndex;
    function setActiveIndex() {
      scope.activeIndex = currentActiveIndex;
    }
    if (event.keyCode === DOWNARROW_KEY) {
      currentActiveIndex = crawlArray(length, currentActiveIndex, 1);
      scope.scrollPosition = 'inview#bottom';
      scope.$apply(setActiveIndex);
    } else if (event.keyCode === UPARROW_KEY) {
      currentActiveIndex = crawlArray(length, currentActiveIndex, -1);
      scope.scrollPosition = 'inview#top';
      scope.$apply(setActiveIndex);
    } else if (event.keyCode === ENTER_KEY) {
      scope.selectItem(scope.filteredItemList[currentActiveIndex]);
    }
  }
  return {
    onInputKeyPressHandler: onInputKeyPressHandler,
    onInputClickHandler: onInputClickHandler,
    onInputHandler: onInputHandler,
    onKeyDownHandler: onKeyDownHandler
  };
};
EventsService.$inject = ['$timeout', 'ItemsListService'];
module.exports = EventsService;